import { createAddon } from 'Addons/combine.ts';
import initialize from './initialize.ts';

export default createAddon('fitmentSearch', {
  initialize,
});
